// extracted by mini-css-extract-plugin
export default {"JobAds":"RentalAds_JobAds__BUPul","close_button":"RentalAds_close_button__c7IUQ","ads_mod":"RentalAds_ads_mod__a7AXY","fav_pop_up":"RentalAds_fav_pop_up__Edlki"};